import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import {
  DocumentSettingsRequestPayload,
  DocumentSettingsResponsePayload,
  SettingModel,
  UpdateDocumentSettingsRequestPayload,
  UpdateDocumentSettingsResponsePayload,
} from "@/model/setting/settingModel";
import service from "../baseHttpService";

class SettingService {
  DoGetSettingDetail() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakPayrollAPI.post("/api/setting/GetSettingDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoUpdateSetting(input: SettingModel) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakPayrollAPI.post("/api/setting/UpdateSetting", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetOnBoarding() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakPayrollAPI.post("/api/setting/GetOnBoarding", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateOnBoarding(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakPayrollAPI.post("/api/setting/UpdateOnBoarding", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoGetDocumentSettings(input: DocumentSettingsRequestPayload) {
    return service.peakPayrollAPI.post<DocumentSettingsResponsePayload>(
      "/api/Setting/GetDocumentSettings",
      input,
      SetHeaderService()
    );
  }

  DoUpdateDocumentSettings(input: UpdateDocumentSettingsRequestPayload, options?: {}) {
    return service.peakPayrollAPI.post<UpdateDocumentSettingsResponsePayload>(
      "/api/Setting/UpdateDocumentSettings",
      input,
      SetHeaderService()
    );
  }
}
export default new SettingService();
